import { mergeRefs } from '@chakra-ui/react-utils';
import {
  chakra,
  type ChakraProps,
  forwardRef,
  useModalStyles,
} from '@chakra-ui/react-v2';
import { useMemo } from 'react';

import { useHeaderActionsWidth } from '../useHeaderActionsWidth';
import {
  DRAWER_HEADER_ACTIONS_ATTRIBUTE,
  DRAWER_HEADER_ACTIONS_WIDTH_VAR,
} from './const';

export type DrawerHeaderActionsProps = ChakraProps;

/**
 * Top-right slot of a DrawerHeader for extra controls (the close button is
 * handled separately by the drawer theme). It measures itself and publishes its
 * width to the header, so the header text and overline never run under it.
 * Must be rendered inside a DrawerHeader.
 */
export const DrawerHeaderActions = forwardRef<DrawerHeaderActionsProps, 'div'>(
  (props, forwardedRef) => {
    const { headerActions: headerActionsStyles } = useModalStyles();
    const elementRef = useHeaderActionsWidth<HTMLDivElement>(
      DRAWER_HEADER_ACTIONS_WIDTH_VAR,
    );
    const ref = useMemo(
      () => mergeRefs(forwardedRef, elementRef),
      [forwardedRef, elementRef],
    );

    return (
      <chakra.div
        ref={ref}
        {...{ [DRAWER_HEADER_ACTIONS_ATTRIBUTE]: '' }}
        __css={headerActionsStyles}
        {...props}
      />
    );
  },
);
DrawerHeaderActions.displayName = 'DrawerHeaderActions';
